import { SportType } from '../../court/dto/court.dto';

export enum UserRole {
  ADMIN = 'admin',
  COACH = 'coach',
}

export class InviteAdminToOrganizationDto {
  email: string;

  organizationId: string;
}

export class AddMemberToOrganizationDto {
  email: string;

  // Dashboard-only: the API takes it from the path (`organizations/:id/members`).
  organizationId: string;

  role?: UserRole;

  /**
   * Platform admins only (403 otherwise). `false` adds the member silently —
   * no "you've been added" email. Defaults to `true`.
   */
  notify?: boolean;
}

export class InviteCoachToOrganizationDto {
  email: string;

  organizationId: string;

  firstName: string;

  lastName: string;

  sports: SportType[];
}
